export default () => (
  {
    introduction: i18n.t('help.introduction'),
    general: [
      { title: i18n.t('help.general_1.title'), body:  i18n.t('help.general_1.body')},
      { title: i18n.t('help.general_2.title'), body:  i18n.t('help.general_2.body')},
      { title: i18n.t('help.general_3.title'), body:  i18n.t('help.general_3.body')},
      { title: i18n.t('help.general_4.title'), body:  i18n.t('help.general_4.body')},
      { title: i18n.t('help.general_5.title'), body:  i18n.t('help.general_5.body')},
    ],
    blocks: [
      { title: i18n.t('help.blocks_1.title'), body: i18n.t('help.blocks_1.body') },
      { title: i18n.t('help.blocks_2.title'), body: i18n.t('help.blocks_2.body') },
      { title: i18n.t('help.blocks_3.title'), body: i18n.t('help.blocks_3.body') },
      { title: i18n.t('help.blocks_4.title'), body: i18n.t('help.blocks_4.body') },
      { title: i18n.t('help.blocks_5.title'), body: i18n.t('help.blocks_5.body') },
      { title: i18n.t('help.blocks_6.title'), body: i18n.t('help.blocks_6.body') },
      { title: i18n.t('help.blocks_7.title'), body: i18n.t('help.blocks_7.body') },
      { title: i18n.t('help.blocks_8.title'), body: i18n.t('help.blocks_8.body') },
    ]
  }
)
